export const enGb = {
  userSettings: "User Settings",
};
